module.exports = __webpack_public_path__ + "img/issues_count_dark.c88600c2.svg";